import React, { ReactNode } from 'react'
import { ChevronRight } from '@dasa-health/alma-icons'
import { Chevron, Container, Content, Ico, Subtitle, Title } from './styles'
import { Icon } from '@dasa-health/components-react'
import { useHistory } from 'react-router-dom'
import { ROUTES_PATH } from 'constants/routesPath'
import { BiometyDataType } from 'typings/unico'
import { UNICO_CONSTANTS } from 'redesign/constants'

type CustomModalOrBottomSheetCellProps = {
    user: string
    itens: item[]
}

type item = {
    icon: ReactNode
    title: string
    subtitle: string
    type: 'PASSWORD' | 'OTP' | string
}

export function CustomModalOrBottomSheetCell({ itens, user }: CustomModalOrBottomSheetCellProps) {
    const history = useHistory()
    const biometyDataLS: BiometyDataType = JSON.parse(sessionStorage.getItem(UNICO_CONSTANTS.STORAGE)!)

    const handleClick = (cpf: string, type: string) => {
        const origin = { origin: type }
        const dadosAtualizados = { ...biometyDataLS, ...origin }

        sessionStorage.setItem(UNICO_CONSTANTS.STORAGE, JSON.stringify(dadosAtualizados))

        history.push(type === 'OTP' ? ROUTES_PATH.LOGIN_WITH_OTP : ROUTES_PATH.RECOVER_PASSWORD, { federalId: cpf })
    }

    return (
        <>
            {itens.map((item, index) => (
                <Container key={index} onClick={() => handleClick(user, item.type)}>
                    <Ico>
                        <Icon color="#0037FF" size={24}>
                            {item.icon}
                        </Icon>
                    </Ico>
                    <Content>
                        <Title>{item.title}</Title>
                        <Subtitle>{item.subtitle}</Subtitle>
                    </Content>
                    <Chevron>
                        <Icon color="#161616E0" size={18}>
                            <ChevronRight />
                        </Icon>
                    </Chevron>
                </Container>
            ))}
        </>
    )
}
